import React from "react";
// import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardOverviewCards.css";
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const DashboardOverviewCards = ({ summary = {} }) => {
    const cards = [
        {
            title:    "Employees",
            value:    summary.employees ?? 0,
            subtitle: "Total active employees",
            color:    "#2563eb",
            icon:     "👥",
        },
        {
            title:    "Working",
            value:    summary.working ?? 0,
            subtitle: "Currently working",
            color:    "#16a34a",
            icon:     "🟢",
        },
        {
            title:    "Open Tasks",
            value:    summary.open_tasks ?? 0,
            subtitle: "Tasks requiring attention",
            color:    "#ea580c",
            icon:     "📋",
        },
        {
            title:    "Completed Today",
            value:    summary.completed_today ?? 0,
            subtitle: "Finished today",
            color:    "#7c3aed",
            icon:     "✅",
        },
    ];

    return (
        // <div className="overview-grid">
        //     {cards.map((card) => (
        //         <div
        //             key={card.title}
        //             className="overview-card"
        //         >
        //             <div className="overview-card-top">

        //                 <div
        //                     className="overview-icon"
        //                     style={{
        //                         background: `${card.color}15`,
        //                         color: card.color,
        //                     }}
        //                 >
        //                     {card.icon}
        //                 </div>

        //                 <div
        //                     className="overview-value"
        //                     style={{
        //                         color: card.color,
        //                     }}
        //                 >
        //                     {card.value}
        //                 </div>

        //             </div>

        //             <div className="overview-title">
        //                 {card.title}
        //             </div>

        //             <div className="overview-subtitle">
        //                 {card.subtitle}
        //             </div>
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards }/>
    );
};

export default DashboardOverviewCards;
